import gql from 'graphql-tag';

export default gql`
query calculateVoucherDiscount(
    $draftOrderId: String
    $storeId: String!
    $voucherIds: [Int]!
    $userId: String!
    $buyerId: Int!
) {
    calculateVoucherDiscount(
        input: {
            draftOrderId: $draftOrderId
            storeId: $storeId
            voucherIds: $voucherIds
            userId: $userId
            buyerId: $buyerId
        }
    ) {
        total
    }
}`;